import React from 'react';

function TilastotSection() {
  return (
    <>
      <p>
        Pulina tarjoaa tapahtumien järjestäille työkaluja, joilla he voivat seurata osallistujien määrää ja saada
        arvosteluja osallistuneilta käyttäjiltä.
      </p>
      <p>
        Pulina on vasta alkutaipaleellaan ja Pulina kehittyy jatkuvasti. Lisään tilastoja sitä mukaa, kun niille tarvetta
        ilmenee.
      </p>
    </>
  );
}

export default TilastotSection;

